<template>
<div class="m-4" id="policy">
</div>
</template>

<script>
export default {
    name: 'policy',
    components: {
    },
    data: () =>({
        faqData: '',
        privacyData: '',
        slaData: ''
    }),
    computed: {
    },
    methods: {
    },
    mounted() {
         let docType = this.$route.query.type
          if(docType == 'sla'){
          this.$store.dispatch('ACTION_GET_STATIC_PAGE', {directory: 'documents', document_type: 'sla'}).then(res => {
            let slaHtml  = atob(res)
            document.write(slaHtml)
             let titleTag = document.createElement('title')
        let textNode = document.createTextNode('Service Level Agreements')
            titleTag.appendChild(textNode)
        document.getElementsByTagName('head')[0].appendChild(titleTag)
        })
        }
      else if(docType == 'msa') {
      this.$store.dispatch('ACTION_GET_STATIC_PAGE', {directory: 'documents', document_type: 'eula'}).then(res => {
          this.slaData = atob(res)
          document.write(this.slaData)
           let titleTag = document.createElement('title')
        let textNode = document.createTextNode('End User License Agreement')
            titleTag.appendChild(textNode)
        document.getElementsByTagName('head')[0].appendChild(titleTag)
      })
      }
      else if (docType == 'privacy') {
        this.$store.dispatch('ACTION_GET_STATIC_PAGE', {directory: 'documents', document_type: 'privacyPolicy'}).then(res => {
            this.privacyData = atob(res)
            document.write(this.privacyData)
           let titleTag = document.createElement('title')
        let textNode = document.createTextNode('Privacy Policy')
            titleTag.appendChild(textNode)
        document.getElementsByTagName('head')[0].appendChild(titleTag)
            // console.log(this.privacyData)
            // var policyDiv = document.createElement('div'); // is a node
            // policyDiv.innerHTML = this.privacyData.toString();
            // document.getElementById('policy').appendChild(policyDiv);
        })
      }
    },
  created () {
     
      
  }
}
</script>